"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneCountry = void 0;
const libphonenumber_js_1 = require("libphonenumber-js");
const types_1 = require("@smartsuite/types");
const formatPhoneCountry = (value, defaultCountry = types_1.DEFAULT_COUNTRY) => {
    var _a;
    try {
        if (!value.phone_number) {
            return types_1.DEFAULT_COUNTRY;
        }
        const phoneNumber = (0, libphonenumber_js_1.parsePhoneNumber)(value.phone_number);
        return (_a = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.country) !== null && _a !== void 0 ? _a : types_1.DEFAULT_COUNTRY;
    }
    catch (e) {
        return defaultCountry;
    }
};
exports.formatPhoneCountry = formatPhoneCountry;
